import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import { API_BASE } from '../config';

function VenditeForm() {
    const [formData, setFormData] = useState({
        alloggio: '',
        scala: '',
        piano: '',
        locali: '',
        mq_commerciali: '',
        prezzo_mq: '',
        listino_alloggio: '',
        sconto_alloggio: '',
        listino_box: '',
        sconto_box: '',
        prezzo_vendita_alloggio: '',
        varianti_alloggio: '',
        cliente: '',
        cliente_box: '',
    });
    const { id, venditaId } = useParams();
    const isEditing = Boolean(venditaId);
    const navigate = useNavigate();

    useEffect(() => {
        if (isEditing) {
            axios.get(`${API_BASE}/vendite/${venditaId}`)
                .then(res => setFormData(res.data));
        }
    }, [venditaId, isEditing]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = { ...formData, cantiere_id: id };

        try {
            if (isEditing) {
                await axios.put(`${API_BASE}/vendite/${venditaId}`, payload);
            } else {
                await axios.post(`${API_BASE}/vendite`, payload);
            }
            navigate(`/dashboard/${id}/vendite`);
        } catch (err) {
            alert("Errore durante il salvataggio");
        }
    };

    const handleChange = (e) => {
        setFormData({...formData, [e.target.name]: e.target.value});
        // puoi aggiungere calcoli dinamici come hai già fatto
    };

    return (
        <div className="container">
            <h3>{isEditing ? 'Modifica Vendita' : 'Aggiungi Vendita'}</h3>
            <form onSubmit={handleSubmit} className="row g-3">
                {Object.keys(formData).map((key) => (
                    ['prezzo_vendita_alloggio', 'prezzo_mq', 'realizzo_box', 'id'].includes(key) ? null :
                        <div className="col-md-6" key={key}>
                            <label className="form-label">{key.replace(/_/g, ' ')}</label>
                            <input
                                type="text"
                                name={key}
                                value={formData[key]}
                                onChange={handleChange}
                                className="form-control"
                            />
                        </div>
                ))}
                <div className="col-12">
                    <button type="submit" className="btn btn-success">
                        {isEditing ? 'Salva Modifiche' : 'Aggiungi Vendita'}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default VenditeForm;